import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { PricingRuleAction } from '@cbridge-packages/pricing-rules';
import { RulesManagementAction } from '@cbridge-modules/rules-management-page';

export const onUpdatePricingRulesDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    PricingRuleAction.update.done,
  ),
  mergeMap(() => {
    return [
      RulesManagementAction.endEditing(undefined),
    ];
  }),
);
